import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import HealthInsurance from "./tabs/HealthInsurance";
import { Wrapper } from "../styled";

const conditionsTabs = [
  {
    title: "Жилищные условия",
    component: <HealthInsurance />,
  }
];

const Conditions: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {conditionsTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {conditionsTabs[tab].component}
    </Wrapper>
  );
};

export default Conditions;
